import styled from '@emotion/styled'
import { motion } from 'framer-motion'
import React, { useEffect, useRef, useState } from 'react'
import { RxDragHandleDots2 } from 'react-icons/rx'
import { clearInterval, clearTimeout, setInterval, setTimeout } from 'worker-timers'

import down from '@/assets/images/down.png'
import muteClose from '@/assets/images/mute-close.png'
import muteOpen from '@/assets/images/mute-open.png'
import videoClose from '@/assets/images/video-close.png'
import videoOpen from '@/assets/images/video-open.png'
import { ipcInvoke, ipcOn } from '@/utils/electron'

export default function Index() {
  const boardControl = useRef<any>()
  const [timerStr, setTimerStr] = useState<string>('00:00')
  const [isMute, setIsMute] = useState(false)
  const [openVideo, setOpenVideo] = useState(true)

  useEffect(() => {
    const startTime = Date.now()
    const timer = setInterval(() => {
      const elapsed = Date.now() - startTime
      const minutes = Math.floor(elapsed / 60000)
      const seconds = Math.floor((elapsed % 60000) / 1000)
      setTimerStr(`${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`)
    }, 1000)

    return () => clearInterval(timer)
  }, [])

  useEffect(() => {
    const timer = setTimeout(() => {
      ipcInvoke('win', { method: 'setContentProtection' }, true)
      ipcInvoke('win', { method: 'setAlwaysOnTop' }, true, 'screen-saver')
      // ipcInvoke('win', { method: 'setVisibleOnAllWorkspaces' }, true, {
      //   visibleOnFullScreen: true
      // })
    }, 150)

    ipcInvoke('custom', {
      method: 'msg',
      toWinName: 'mainWin',
      data: { loaded: true }
    })

    ipcOn('msg', (event, result, ...args) => {
      const { data } = result
      if ('close' in data) {
        ipcInvoke('win', { method: 'close' })
      }
      if ('isMute' in data) {
        console.log('🚀 ~ ipcOn ~ isMute:', data.isMute)

        setIsMute(data.isMute)
      }
      if ('openVideo' in data) {
        setOpenVideo(data.openVideo)
      }
      if ('focus' in data) {
        console.log(result)
        if (!data.focus) {
          ipcInvoke('win', { method: 'focus' })
        }
      }
    })
    return () => clearTimeout(timer)
  }, [])

  return (
    <Container className=" w-screen h-screen flex items-center  flex-col bg-[rgba(255,255,255,0)] select-none relative">
      <div ref={boardControl} className={`w-[290px] h-[80px] bg-[#000000] rounded-[6px] flex items-center justify-center absolute z-[10]`}>
        <div className="drag cursor w-[70px] flex items-center justify-center cursor-pointer">
          <RxDragHandleDots2 className="text-[36px] text-[#656565]" />
        </div>
        <div className="flex flex-1  items-center justify-evenly">
          <div className="flex w-[80px] flex-col items-center justify-center">
            <div
              onClick={() =>
                ipcInvoke('custom', {
                  method: 'msg',
                  toWinName: 'mainWin',
                  data: { setMute: isMute }
                })
              }
              className="w-[31px] h-[31px] mb-[5px] cursor-pointer anim_btn2"
            >
              {isMute ? <img className="h-full" src={muteOpen}></img> : <img className="h-full" src={muteClose}></img>}
            </div>
            <div className="text-[#D5D5D6] text-[12px]">{isMute ? '解除静音' : '静音'}</div>
          </div>
          <div className="flex w-[80px] flex-col items-center justify-center">
            <div
              onClick={() =>
                ipcInvoke('custom', {
                  method: 'msg',
                  toWinName: 'mainWin',
                  data: { setOpenVideo: openVideo }
                })
              }
              className="w-[31px] h-[31px] mb-[5px] cursor-pointer anim_btn2"
            >
              {openVideo ? <img className="h-full" src={videoOpen}></img> : <img className="h-full" src={videoClose}></img>}
            </div>
            <div className="text-[#D5D5D6] text-[12px]">{openVideo ? '关闭视频' : '开启视频'}</div>
          </div>
        </div>
        <div className="absolute z-[-1] bottom-[-38px] left-[calc(50% - 158px)] w-[238px] h-[38px] rounded-b-[6px] flex items-center justify-evenly " style={{ backgroundColor: 'rgba(0,0,0,0.8)' }}>
          <div className="flex items-center justify-around w-full h-full text-[#00A239] px-[10px]">
            <img src={down} className="w-[13px] h-[15px]" /> 共享中 <span className="w-[50px]"> {timerStr}</span>
          </div>
          <div
            className="cursor-pointer flex w-[150px] h-full items-center justify-center bg-[#000] rounded-b-[6px]  text-[#F3561D]"
            onClick={() =>
              ipcInvoke('custom', {
                method: 'msg',
                toWinName: 'screenRecordMark',
                data: { exit: true }
              })
            }
          >
            结束共享
          </div>
        </div>
      </div>
    </Container>
  )
}

const Container = styled(motion.div)`
  .drag {
    app-region: drag;
  }
`
